import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HFTStudioPage from '../hft-studio/HftStudioPage';
import TickLakePage from '../tickLake/TickLakePage';
import Screeners from '../../components/Screeners/Screeners';
import { useShellNav } from '../shell/ShellNavContext';
import { shellTokens } from '../shell/theme/shellTheme';

const RESEARCH_TOOLS = [
    {
        value: 'hftstudio',
        label: 'HFT Studio',
        description: 'Calendar → day → segments → chain',
        Icon: ViewModuleOutlinedIcon,
        Component: HFTStudioPage,
    },
    {
        value: 'ticklake',
        label: 'Tick Studio',
        description: 'OHLC · OBI · backtest',
        Icon: ShowChartOutlinedIcon,
        Component: TickLakePage,
    },
    {
        value: 'screeners',
        label: 'Screeners',
        description: '52-week high and more',
        Icon: TableRowsOutlinedIcon,
        Component: Screeners,
    },
];

const VALID_TOOLS = new Set(RESEARCH_TOOLS.map((tool) => tool.value));

const tileSx = {
    border: `1px solid ${shellTokens.border}`,
    borderRadius: `${shellTokens.innerRadius}px`,
    p: 2,
    bgcolor: shellTokens.surface,
    cursor: 'pointer',
    textAlign: 'center',
    fontFamily: 'inherit',
    '&:hover': { bgcolor: 'rgba(15, 23, 42, 0.03)' },
};

const ResearchPage = () => {
    const { subTab, setSubTab } = useShellNav();
    const [activeTool, setActiveTool] = useState(null);

    useEffect(() => {
        if (subTab && VALID_TOOLS.has(subTab)) {
            setActiveTool(subTab);
        }
    }, [subTab]);

    const handleToolClick = (value) => {
        setActiveTool(value);
        setSubTab(value);
    };

    const handleBack = () => {
        setActiveTool(null);
        setSubTab(null);
    };

    const selected = RESEARCH_TOOLS.find((tool) => tool.value === activeTool);

    if (selected) {
        const { Component } = selected;
        return (
            <Box>
                <Button
                    size="small"
                    startIcon={<ArrowBackIcon />}
                    onClick={handleBack}
                    sx={{
                        mb: 1.5,
                        fontSize: '0.78rem',
                        fontWeight: 600,
                        color: shellTokens.muted,
                        textTransform: 'none',
                    }}
                >
                    All research tools
                </Button>
                <Component />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                gap: 1.25,
            }}
        >
            {RESEARCH_TOOLS.map(({ value, label, description, Icon }) => (
                <Box
                    key={value}
                    component="button"
                    type="button"
                    onClick={() => handleToolClick(value)}
                    sx={tileSx}
                >
                    <Icon sx={{ fontSize: '1.4rem', mb: 0.75, color: shellTokens.muted }} />
                    <Typography sx={{ fontSize: '0.82rem', fontWeight: 600, color: shellTokens.text }}>
                        {label}
                    </Typography>
                    <Typography sx={{ fontSize: '0.72rem', color: shellTokens.muted, mt: 0.5, lineHeight: 1.4 }}>
                        {description}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default ResearchPage;
